import React from 'react'
import Puzzle from 'react-image-puzzle'
import { useWindowSize } from 'react-use'
import { useDispatch } from 'react-redux'
import gameActions from '../../../store/actions/gameActions'

const PuzzleMinigame = ({ img }) => {
    const dispatch = useDispatch()
    const { width } = useWindowSize()

    return (
        <div className='grid grid-cols-1 items-center justify-center gap-0 py-8 md:py-10'>
            <h4 className='pb-0'>Puzzle</h4>
            <p className='pb-4'>Complete o puzzle da imagem para conseguir avançar!</p>

            <div className='grid grid-cols-1 md:grid-cols-2 gap-8 py-8 md:py-10'>
                <div>
                    <img
                        className='object-cover h-full'
                        style={{ filter: 'blur(10px)', msFilter: 'blur(10px)' }}
                        src={require(`../../../assets/img/narrative/${img}`)}
                        alt='Imagem desfocada de puzzle'
                        title='Imagem desfocada de puzzle'
                    />
                </div>
                <div className='flex justify-center items-center'>
                    <Puzzle
                        level={3}
                        size={width < 350 ? 200 : 300}
                        image={require(`../../../assets/img/narrative/${img}`)}
                        onDone={() => dispatch(gameActions.unlockAdvancedNarrative('puzzle'))}
                    />
                </div>
            </div>
        </div>
    )
}

export default PuzzleMinigame